module.exports = {
  "AR One Sans": "AR One Sans, sans-serif",
  "Abhaya Libre": "Abhaya Libre, serif",
  "Abril Fatface": "Abril Fatface, fantasy",
  "Advent Pro": "Advent Pro, sans-serif",
  "Afacad": "Afacad, sans-serif",
  "Afacad Flux": "Afacad Flux, sans-serif",
  "Agdasima": "Agdasima, sans-serif",
  "Akatab": "Akatab, sans-serif",
  "Akshar": "Akshar, sans-serif",
  "Albert Sans": "Albert Sans, sans-serif",
  "Alef": "Alef, sans-serif",
  "Alegreya": "Alegreya, serif",
  "Alegreya SC": "Alegreya SC, serif",
  "Alegreya Sans": "Alegreya Sans, sans-serif",
  "Alegreya Sans SC": "Alegreya Sans SC, sans-serif",
  "Aleo": "Aleo, serif",
  "Alexandria": "Alexandria, sans-serif",
  "Alkatra": "Alkatra, fantasy",
  "Allan": "Allan, fantasy",
  "Almarai": "Almarai, sans-serif",
  "Almendra": "Almendra, serif",
  "Alumni Sans": "Alumni Sans, sans-serif",
  "Amaranth": "Amaranth, sans-serif",
  "Amatic SC": "Amatic SC, sans-serif",
  "Amiko": "Amiko, sans-serif",
  "Amiri": "Amiri, serif",
  "Amita": "Amita, sans-serif",
  "Anaheim": "Anaheim, sans-serif",
  "Andada Pro": "Andada Pro, serif",
  "Andika": "Andika, sans-serif",
  "Anek Bangla": "Anek Bangla, sans-serif",
  "Anek Devanagari": "Anek Devanagari, sans-serif",
  "Anek Gujarati": "Anek Gujarati, sans-serif",
  "Anek Gurmukhi": "Anek Gurmukhi, sans-serif",
  "Anek Kannada": "Anek Kannada, sans-serif",
  "Anek Latin": "Anek Latin, sans-serif",
  "Anek Malayalam": "Anek Malayalam, sans-serif",
  "Anek Odia": "Anek Odia, sans-serif",
  "Anek Tamil": "Anek Tamil, sans-serif",
  "Anek Telugu": "Anek Telugu, sans-serif",
  "Annapurna SIL": "Annapurna SIL, serif",
  "Anonymous Pro": "Anonymous Pro, monospace",
  "Antonio": "Antonio, sans-serif",
  "Anuphan": "Anuphan, sans-serif",
  "Anybody": "Anybody, fantasy",
  "Archivo": "Archivo, sans-serif",
  "Archivo Narrow": "Archivo Narrow, sans-serif",
  "Aref Ruqaa": "Aref Ruqaa, serif",
  "Aref Ruqaa Ink": "Aref Ruqaa Ink, serif",
  "Arima": "Arima, fantasy",
  "Arimo": "Arimo, sans-serif",
  "Arsenal": "Arsenal, sans-serif",
  "Arsenal SC": "Arsenal SC, sans-serif",
  "Arvo": "Arvo, serif",
  "Arya": "Arya, sans-serif",
  "Asap": "Asap, sans-serif",
  "Asap Condensed": "Asap Condensed, sans-serif",
  "Assistant": "Assistant, sans-serif",
  "Astloch": "Astloch, fantasy",
  "Asul": "Asul, sans-serif",
  "Athiti": "Athiti, sans-serif",
  "Atkinson Hyperlegible": "Atkinson Hyperlegible, sans-serif",
  "Atma": "Atma, fantasy",
  "Averia Libre": "Averia Libre, fantasy",
  "Averia Sans Libre": "Averia Sans Libre, fantasy",
  "Averia Serif Libre": "Averia Serif Libre, fantasy",
  "Azeret Mono": "Azeret Mono, monospace",
  "B612": "B612, sans-serif",
  "B612 Mono": "B612 Mono, monospace",
  "BIZ UDGothic": "BIZ UDGothic, sans-serif",
  "BIZ UDMincho": "BIZ UDMincho, serif",
  "BIZ UDPGothic": "BIZ UDPGothic, sans-serif",
  "BIZ UDPMincho": "BIZ UDPMincho, serif",
  "Bai Jamjuree": "Bai Jamjuree, sans-serif",
  "Baloo 2": "Baloo 2, fantasy",
  "Baloo Bhai 2": "Baloo Bhai 2, fantasy",
  "Baloo Bhaijaan 2": "Baloo Bhaijaan 2, fantasy",
  "Baloo Bhaina 2": "Baloo Bhaina 2, fantasy",
  "Baloo Chettan 2": "Baloo Chettan 2, fantasy",
  "Baloo Da 2": "Baloo Da 2, fantasy",
  "Baloo Paaji 2": "Baloo Paaji 2, fantasy",
  "Baloo Tamma 2": "Baloo Tamma 2, fantasy",
  "Baloo Tammudu 2": "Baloo Tammudu 2, fantasy",
  "Baloo Thambi 2": "Baloo Thambi 2, fantasy",
  "Balsamiq Sans": "Balsamiq Sans, fantasy",
  "Barlow": "Barlow, sans-serif",
  "Barlow Condensed": "Barlow Condensed, sans-serif",
  "Barlow Semi Condensed": "Barlow Semi Condensed, sans-serif",
  "Battambang": "Battambang, fantasy",
  "Be Vietnam Pro": "Be Vietnam Pro, sans-serif",
  "Beiruti": "Beiruti, sans-serif",
  "Belanosima": "Belanosima, sans-serif",
  "Bellota": "Bellota, fantasy",
  "Bellota Text": "Bellota Text, fantasy",
  "BenchNine": "BenchNine, sans-serif",
  "Besley": "Besley, serif",
  "Big Shoulders Display": "Big Shoulders Display, fantasy",
  "Big Shoulders Inline Display": "Big Shoulders Inline Display, fantasy",
  "Big Shoulders Inline Text": "Big Shoulders Inline Text, fantasy",
  "Big Shoulders Stencil Display": "Big Shoulders Stencil Display, fantasy",
  "Big Shoulders Stencil Text": "Big Shoulders Stencil Text, fantasy",
  "Big Shoulders Text": "Big Shoulders Text, fantasy",
  "BioRhyme": "BioRhyme, serif",
  "BioRhyme Expanded": "BioRhyme Expanded, serif",
  "Biryani": "Biryani, sans-serif",
  "Bitter": "Bitter, serif",
  "Blinker": "Blinker, sans-serif",
  "Bodoni Moda": "Bodoni Moda, serif",
  "Bodoni Moda SC": "Bodoni Moda SC, serif",
  "Bona Nova": "Bona Nova, serif",
  "Bona Nova SC": "Bona Nova SC, serif",
  "Brawler": "Brawler, serif",
  "Bricolage Grotesque": "Bricolage Grotesque, sans-serif",
  "Brygada 1918": "Brygada 1918, serif",
  "Buenard": "Buenard, serif",
  "Cabin": "Cabin, sans-serif",
  "Cabin Condensed": "Cabin Condensed, sans-serif",
  "Cabin Sketch": "Cabin Sketch, fantasy",
  "Cairo": "Cairo, sans-serif",
  "Cairo Play": "Cairo Play, sans-serif",
  "Caladea": "Caladea, serif",
  "Cambay": "Cambay, sans-serif",
  "Cantarell": "Cantarell, sans-serif",
  "Cardo": "Cardo, serif",
  "Carlito": "Carlito, sans-serif",
  "Catamaran": "Catamaran, sans-serif",
  "Caudex": "Caudex, serif",
  "Caveat": "Caveat, sans-serif",
  "Chakra Petch": "Chakra Petch, sans-serif",
  "Changa": "Changa, sans-serif",
  "Charis SIL": "Charis SIL, serif",
  "Charm": "Charm, sans-serif",
  "Charmonman": "Charmonman, sans-serif",
  "Chathura": "Chathura, sans-serif",
  "Cherry Swash": "Cherry Swash, fantasy",
  "Chivo": "Chivo, sans-serif",
  "Chivo Mono": "Chivo Mono, monospace",
  "Cinzel": "Cinzel, serif",
  "Cinzel Decorative": "Cinzel Decorative, fantasy",
  "Comfortaa": "Comfortaa, fantasy",
  "Comic Neue": "Comic Neue, sans-serif",
  "Comme": "Comme, sans-serif",
  "Commissioner": "Commissioner, sans-serif",
  "Content": "Content, fantasy",
  "Corben": "Corben, fantasy",
  "Corinthia": "Corinthia, sans-serif",
  "Cormorant": "Cormorant, serif",
  "Cormorant Garamond": "Cormorant Garamond, serif",
  "Cormorant Infant": "Cormorant Infant, serif",
  "Cormorant SC": "Cormorant SC, serif",
  "Cormorant Unicase": "Cormorant Unicase, serif",
  "Cormorant Upright": "Cormorant Upright, serif",
  "Courier Prime": "Courier Prime, monospace",
  "Cousine": "Cousine, monospace",
  "Crimson Pro": "Crimson Pro, serif",
  "Crimson Text": "Crimson Text, serif",
  "Cuprum": "Cuprum, sans-serif",
  "DM Sans": "DM Sans, sans-serif",
  "Dai Banna SIL": "Dai Banna SIL, serif",
  "Dancing Script": "Dancing Script, sans-serif",
  "Darker Grotesque": "Darker Grotesque, sans-serif",
  "David Libre": "David Libre, serif",
  "Delius Unicase": "Delius Unicase, sans-serif",
  "Domine": "Domine, serif",
  "Dongle": "Dongle, sans-serif",
  "Dosis": "Dosis, sans-serif",
  "Doto": "Doto, sans-serif",
  "DynaPuff": "DynaPuff, fantasy",
  "EB Garamond": "EB Garamond, serif",
  "Economica": "Economica, sans-serif",
  "Eczar": "Eczar, serif",
  "Edu AU VIC WA NT Arrows": "Edu AU VIC WA NT Arrows, sans-serif",
  "Edu AU VIC WA NT Dots": "Edu AU VIC WA NT Dots, sans-serif",
  "Edu AU VIC WA NT Guides": "Edu AU VIC WA NT Guides, sans-serif",
  "Edu AU VIC WA NT Hand": "Edu AU VIC WA NT Hand, sans-serif",
  "Edu AU VIC WA NT Pre": "Edu AU VIC WA NT Pre, sans-serif",
  "Edu NSW ACT Foundation": "Edu NSW ACT Foundation, sans-serif",
  "Edu QLD Beginner": "Edu QLD Beginner, sans-serif",
  "Edu SA Beginner": "Edu SA Beginner, sans-serif",
  "Edu TAS Beginner": "Edu TAS Beginner, sans-serif",
  "Edu VIC WA NT Beginner": "Edu VIC WA NT Beginner, sans-serif",
  "El Messiri": "El Messiri, sans-serif",
  "Encode Sans": "Encode Sans, sans-serif",
  "Encode Sans Condensed": "Encode Sans Condensed, sans-serif",
  "Encode Sans Expanded": "Encode Sans Expanded, sans-serif",
  "Encode Sans SC": "Encode Sans SC, sans-serif",
  "Encode Sans Semi Condensed": "Encode Sans Semi Condensed, sans-serif",
  "Encode Sans Semi Expanded": "Encode Sans Semi Expanded, sans-serif",
  "Enriqueta": "Enriqueta, serif",
  "Epilogue": "Epilogue, sans-serif",
  "Exo": "Exo, sans-serif",
  "Exo 2": "Exo 2, sans-serif",
  "Expletus Sans": "Expletus Sans, fantasy",
  "Fahkwang": "Fahkwang, sans-serif",
  "Familjen Grotesk": "Familjen Grotesk, sans-serif",
  "Farro": "Farro, sans-serif",
  "Faustina": "Faustina, serif",
  "Figtree": "Figtree, sans-serif",
  "Finlandica": "Finlandica, sans-serif",
  "Fira Code": "Fira Code, monospace",
  "Fira Mono": "Fira Mono, monospace",
  "Fira Sans": "Fira Sans, sans-serif",
  "Fira Sans Condensed": "Fira Sans Condensed, sans-serif",
  "Fira Sans Extra Condensed": "Fira Sans Extra Condensed, sans-serif",
  "Foldit": "Foldit, fantasy",
  "Frank Ruhl Libre": "Frank Ruhl Libre, serif",
  "Fraunces": "Fraunces, serif",
  "Fredoka": "Fredoka, sans-serif",
  "Funnel Display": "Funnel Display, fantasy",
  "Funnel Sans": "Funnel Sans, sans-serif",
  "Fustat": "Fustat, sans-serif",
  "Fuzzy Bubbles": "Fuzzy Bubbles, sans-serif",
  "GFS Neohellenic": "GFS Neohellenic, sans-serif",
  "Gabarito": "Gabarito, fantasy",
  "Gaegu": "Gaegu, sans-serif",
  "Gantari": "Gantari, sans-serif",
  "Gayathri": "Gayathri, sans-serif",
  "Geist": "Geist, sans-serif",
  "Geist Mono": "Geist Mono, monospace",
  "Gelasio": "Gelasio, serif",
  "Gemunu Libre": "Gemunu Libre, sans-serif",
  "Genos": "Genos, sans-serif",
  "Gentium Book Plus": "Gentium Book Plus, serif",
  "Gentium Plus": "Gentium Plus, serif",
  "Geologica": "Geologica, sans-serif",
  "Georama": "Georama, sans-serif",
  "Glegoo": "Glegoo, serif",
  "Glory": "Glory, sans-serif",
  "Gluten": "Gluten, fantasy",
  "Goldman": "Goldman, fantasy",
  "Golos Text": "Golos Text, sans-serif",
  "Gorditas": "Gorditas, fantasy",
  "Gothic A1": "Gothic A1, sans-serif",
  "Gowun Batang": "Gowun Batang, serif",
  "Grandstander": "Grandstander, fantasy",
  "Grenze": "Grenze, serif",
  "Grenze Gotisch": "Grenze Gotisch, fantasy",
  "Gudea": "Gudea, sans-serif",
  "Gupter": "Gupter, serif",
  "Gwendolyn": "Gwendolyn, sans-serif",
  "Hahmlet": "Hahmlet, serif",
  "Halant": "Halant, serif",
  "Handjet": "Handjet, fantasy",
  "Hanken Grotesk": "Hanken Grotesk, sans-serif",
  "Hanuman": "Hanuman, serif",
  "Harmattan": "Harmattan, sans-serif",
  "Heebo": "Heebo, sans-serif",
  "Hepta Slab": "Hepta Slab, serif",
  "Hind": "Hind, sans-serif",
  "Hind Guntur": "Hind Guntur, sans-serif",
  "Hind Madurai": "Hind Madurai, sans-serif",
  "Hind Mysuru": "Hind Mysuru, sans-serif",
  "Hind Siliguri": "Hind Siliguri, sans-serif",
  "Hind Vadodara": "Hind Vadodara, sans-serif",
  "Host Grotesk": "Host Grotesk, sans-serif",
  "Hubot Sans": "Hubot Sans, sans-serif",
  "IBM Plex Mono": "IBM Plex Mono, monospace",
  "IBM Plex Sans": "IBM Plex Sans, sans-serif",
  "IBM Plex Sans Arabic": "IBM Plex Sans Arabic, sans-serif",
  "IBM Plex Sans Condensed": "IBM Plex Sans Condensed, sans-serif",
  "IBM Plex Sans Devanagari": "IBM Plex Sans Devanagari, sans-serif",
  "IBM Plex Sans Hebrew": "IBM Plex Sans Hebrew, sans-serif",
  "IBM Plex Sans JP": "IBM Plex Sans JP, sans-serif",
  "IBM Plex Sans KR": "IBM Plex Sans KR, sans-serif",
  "IBM Plex Sans Thai": "IBM Plex Sans Thai, sans-serif",
  "IBM Plex Sans Thai Looped": "IBM Plex Sans Thai Looped, sans-serif",
  "IBM Plex Serif": "IBM Plex Serif, serif",
  "Ibarra Real Nova": "Ibarra Real Nova, serif",
  "Imbue": "Imbue, serif",
  "Inconsolata": "Inconsolata, monospace",
  "Inika": "Inika, serif",
  "Inknut Antiqua": "Inknut Antiqua, serif",
  "Inria Sans": "Inria Sans, sans-serif",
  "Inria Serif": "Inria Serif, serif",
  "Instrument Sans": "Instrument Sans, sans-serif",
  "Inter": "Inter, sans-serif",
  "Inter Tight": "Inter Tight, sans-serif",
  "Istok Web": "Istok Web, sans-serif",
  "Jaldi": "Jaldi, sans-serif",
  "JetBrains Mono": "JetBrains Mono, monospace",
  "Josefin Sans": "Josefin Sans, sans-serif",
  "Josefin Slab": "Josefin Slab, serif",
  "Jost": "Jost, sans-serif",
  "Judson": "Judson, serif",
  "Jura": "Jura, sans-serif",
  "K2D": "K2D, sans-serif",
  "Kadwa": "Kadwa, serif",
  "Kaisei Decol": "Kaisei Decol, serif",
  "Kaisei HarunoUmi": "Kaisei HarunoUmi, serif",
  "Kaisei Opti": "Kaisei Opti, serif",
  "Kaisei Tokumin": "Kaisei Tokumin, serif",
  "Kalam": "Kalam, sans-serif",
  "Kalnia": "Kalnia, serif",
  "Kalnia Glaze": "Kalnia Glaze, fantasy",
  "Kameron": "Kameron, serif",
  "Kanit": "Kanit, sans-serif",
  "Kantumruy Pro": "Kantumruy Pro, sans-serif",
  "Karantina": "Karantina, fantasy",
  "Karla": "Karla, sans-serif",
  "Karla Tamil Inclined": "Karla Tamil Inclined, sans-serif",
  "Karla Tamil Upright": "Karla Tamil Upright, sans-serif",
  "Karma": "Karma, serif",
  "Kay Pho Du": "Kay Pho Du, serif",
  "Khand": "Khand, sans-serif",
  "Khula": "Khula, sans-serif",
  "KoHo": "KoHo, sans-serif",
  "Kodchasan": "Kodchasan, sans-serif",
  "Kode Mono": "Kode Mono, monospace",
  "Koh Santepheap": "Koh Santepheap, serif",
  "Kreon": "Kreon, serif",
  "Krub": "Krub, sans-serif",
  "Kufam": "Kufam, sans-serif",
  "Kulim Park": "Kulim Park, sans-serif",
  "Kumbh Sans": "Kumbh Sans, sans-serif",
  "LXGW WenKai Mono TC": "LXGW WenKai Mono TC, monospace",
  "LXGW WenKai TC": "LXGW WenKai TC, sans-serif",
  "Labrada": "Labrada, serif",
  "Laila": "Laila, sans-serif",
  "Lateef": "Lateef, serif",
  "Lato": "Lato, sans-serif",
  "League Spartan": "League Spartan, sans-serif",
  "Lekton": "Lekton, monospace",
  "Lemonada": "Lemonada, fantasy",
  "Lexend": "Lexend, sans-serif",
  "Lexend Deca": "Lexend Deca, sans-serif",
  "Lexend Exa": "Lexend Exa, sans-serif",
  "Lexend Giga": "Lexend Giga, sans-serif",
  "Lexend Mega": "Lexend Mega, sans-serif",
  "Lexend Peta": "Lexend Peta, sans-serif",
  "Lexend Tera": "Lexend Tera, sans-serif",
  "Lexend Zetta": "Lexend Zetta, sans-serif",
  "Libre Baskerville": "Libre Baskerville, serif",
  "Libre Bodoni": "Libre Bodoni, serif",
  "Libre Caslon Text": "Libre Caslon Text, serif",
  "Libre Franklin": "Libre Franklin, sans-serif",
  "Life Savers": "Life Savers, fantasy",
  "Linefont": "Linefont, fantasy",
  "Lisu Bosa": "Lisu Bosa, serif",
  "Literata": "Literata, serif",
  "Livvic": "Livvic, sans-serif",
  "Lobster Two": "Lobster Two, fantasy",
  "Lora": "Lora, serif",
  "Lunasima": "Lunasima, sans-serif",
  "Lusitana": "Lusitana, serif",
  "M PLUS 1": "M PLUS 1, sans-serif",
  "M PLUS 1 Code": "M PLUS 1 Code, monospace",
  "M PLUS 1p": "M PLUS 1p, sans-serif",
  "M PLUS 2": "M PLUS 2, sans-serif",
  "M PLUS Code Latin": "M PLUS Code Latin, sans-serif",
  "M PLUS Rounded 1c": "M PLUS Rounded 1c, sans-serif",
  "Mada": "Mada, sans-serif",
  "Magra": "Magra, sans-serif",
  "Maitree": "Maitree, serif",
  "Mali": "Mali, sans-serif",
  "Manjari": "Manjari, sans-serif",
  "Manrope": "Manrope, sans-serif",
  "Manuale": "Manuale, serif",
  "Marhey": "Marhey, fantasy",
  "Markazi Text": "Markazi Text, serif",
  "Martel": "Martel, serif",
  "Martel Sans": "Martel Sans, sans-serif",
  "Martian Mono": "Martian Mono, monospace",
  "Marvel": "Marvel, sans-serif",
  "Material Symbols Outlined": "Material Symbols Outlined, monospace",
  "Material Symbols Rounded": "Material Symbols Rounded, monospace",
  "Material Symbols Sharp": "Material Symbols Sharp, monospace",
  "Maven Pro": "Maven Pro, sans-serif",
  "Merienda": "Merienda, sans-serif",
  "Merriweather": "Merriweather, serif",
  "Merriweather Sans": "Merriweather Sans, sans-serif",
  "Mina": "Mina, sans-serif",
  "Miriam Libre": "Miriam Libre, sans-serif",
  "Mirza": "Mirza, serif",
  "Mitr": "Mitr, sans-serif",
  "Moderustic": "Moderustic, sans-serif",
  "Mohave": "Mohave, sans-serif",
  "Mona Sans": "Mona Sans, sans-serif",
  "Monda": "Monda, sans-serif",
  "Montagu Slab": "Montagu Slab, serif",
  "Montserrat": "Montserrat, sans-serif",
  "Montserrat Alternates": "Montserrat Alternates, sans-serif",
  "Montserrat Subrayada": "Montserrat Subrayada, sans-serif",
  "Montserrat Underline": "Montserrat Underline, sans-serif",
  "Mountains of Christmas": "Mountains of Christmas, fantasy",
  "Mukta": "Mukta, sans-serif",
  "Mukta Mahee": "Mukta Mahee, sans-serif",
  "Mukta Malar": "Mukta Malar, sans-serif",
  "Mukta Vaani": "Mukta Vaani, sans-serif",
  "Mulish": "Mulish, sans-serif",
  "Murecho": "Murecho, sans-serif",
  "MuseoModerno": "MuseoModerno, fantasy",
  "Namdhinggo": "Namdhinggo, serif",
  "Nanum Gothic": "Nanum Gothic, sans-serif",
  "Nanum Gothic Coding": "Nanum Gothic Coding, sans-serif",
  "Nanum Myeongjo": "Nanum Myeongjo, serif",
  "Narnoor": "Narnoor, serif",
  "Neuton": "Neuton, serif",
  "News Cycle": "News Cycle, sans-serif",
  "Newsreader": "Newsreader, serif",
  "Niramit": "Niramit, sans-serif",
  "Nobile": "Nobile, sans-serif",
  "Nokora": "Nokora, sans-serif",
  "Noticia Text": "Noticia Text, serif",
  "Noto Emoji": "Noto Emoji, sans-serif",
  "Noto Kufi Arabic": "Noto Kufi Arabic, sans-serif",
  "Noto Naskh Arabic": "Noto Naskh Arabic, serif",
  "Noto Nastaliq Urdu": "Noto Nastaliq Urdu, serif",
  "Noto Rashi Hebrew": "Noto Rashi Hebrew, serif",
  "Noto Sans": "Noto Sans, sans-serif",
  "Noto Sans Adlam": "Noto Sans Adlam, sans-serif",
  "Noto Sans Adlam Unjoined": "Noto Sans Adlam Unjoined, sans-serif",
  "Noto Sans Arabic": "Noto Sans Arabic, sans-serif",
  "Noto Sans Armenian": "Noto Sans Armenian, sans-serif",
  "Noto Sans Balinese": "Noto Sans Balinese, sans-serif",
  "Noto Sans Bamum": "Noto Sans Bamum, sans-serif",
  "Noto Sans Bassa Vah": "Noto Sans Bassa Vah, sans-serif",
  "Noto Sans Bengali": "Noto Sans Bengali, sans-serif",
  "Noto Sans Canadian Aboriginal": "Noto Sans Canadian Aboriginal, sans-serif",
  "Noto Sans Cham": "Noto Sans Cham, sans-serif",
  "Noto Sans Cherokee": "Noto Sans Cherokee, sans-serif",
  "Noto Sans Devanagari": "Noto Sans Devanagari, sans-serif",
  "Noto Sans Display": "Noto Sans Display, sans-serif",
  "Noto Sans Duployan": "Noto Sans Duployan, sans-serif",
  "Noto Sans Ethiopic": "Noto Sans Ethiopic, sans-serif",
  "Noto Sans Georgian": "Noto Sans Georgian, sans-serif",
  "Noto Sans Gujarati": "Noto Sans Gujarati, sans-serif",
  "Noto Sans Gunjala Gondi": "Noto Sans Gunjala Gondi, sans-serif",
  "Noto Sans Gurmukhi": "Noto Sans Gurmukhi, sans-serif",
  "Noto Sans HK": "Noto Sans HK, sans-serif",
  "Noto Sans Hanifi Rohingya": "Noto Sans Hanifi Rohingya, sans-serif",
  "Noto Sans Hebrew": "Noto Sans Hebrew, sans-serif",
  "Noto Sans JP": "Noto Sans JP, sans-serif",
  "Noto Sans Javanese": "Noto Sans Javanese, sans-serif",
  "Noto Sans KR": "Noto Sans KR, sans-serif",
  "Noto Sans Kannada": "Noto Sans Kannada, sans-serif",
  "Noto Sans Kawi": "Noto Sans Kawi, sans-serif",
  "Noto Sans Kayah Li": "Noto Sans Kayah Li, sans-serif",
  "Noto Sans Khmer": "Noto Sans Khmer, sans-serif",
  "Noto Sans Lao": "Noto Sans Lao, sans-serif",
  "Noto Sans Lao Looped": "Noto Sans Lao Looped, sans-serif",
  "Noto Sans Lisu": "Noto Sans Lisu, sans-serif",
  "Noto Sans Malayalam": "Noto Sans Malayalam, sans-serif",
  "Noto Sans Medefaidrin": "Noto Sans Medefaidrin, sans-serif",
  "Noto Sans Meetei Mayek": "Noto Sans Meetei Mayek, sans-serif",
  "Noto Sans Mono": "Noto Sans Mono, sans-serif",
  "Noto Sans Myanmar": "Noto Sans Myanmar, sans-serif",
  "Noto Sans NKo Unjoined": "Noto Sans NKo Unjoined, sans-serif",
  "Noto Sans Nag Mundari": "Noto Sans Nag Mundari, sans-serif",
  "Noto Sans New Tai Lue": "Noto Sans New Tai Lue, sans-serif",
  "Noto Sans Ol Chiki": "Noto Sans Ol Chiki, sans-serif",
  "Noto Sans Oriya": "Noto Sans Oriya, sans-serif",
  "Noto Sans SC": "Noto Sans SC, sans-serif",
  "Noto Sans Sinhala": "Noto Sans Sinhala, sans-serif",
  "Noto Sans Sora Sompeng": "Noto Sans Sora Sompeng, sans-serif",
  "Noto Sans Sundanese": "Noto Sans Sundanese, sans-serif",
  "Noto Sans Symbols": "Noto Sans Symbols, sans-serif",
  "Noto Sans Syriac": "Noto Sans Syriac, sans-serif",
  "Noto Sans Syriac Eastern": "Noto Sans Syriac Eastern, sans-serif",
  "Noto Sans TC": "Noto Sans TC, sans-serif",
  "Noto Sans Tai Tham": "Noto Sans Tai Tham, sans-serif",
  "Noto Sans Tamil": "Noto Sans Tamil, sans-serif",
  "Noto Sans Tangsa": "Noto Sans Tangsa, sans-serif",
  "Noto Sans Telugu": "Noto Sans Telugu, sans-serif",
  "Noto Sans Thaana": "Noto Sans Thaana, sans-serif",
  "Noto Sans Thai": "Noto Sans Thai, sans-serif",
  "Noto Sans Thai Looped": "Noto Sans Thai Looped, sans-serif",
  "Noto Sans Vithkuqi": "Noto Sans Vithkuqi, sans-serif",
  "Noto Serif": "Noto Serif, serif",
  "Noto Serif Armenian": "Noto Serif Armenian, serif",
  "Noto Serif Bengali": "Noto Serif Bengali, serif",
  "Noto Serif Devanagari": "Noto Serif Devanagari, serif",
  "Noto Serif Display": "Noto Serif Display, serif",
  "Noto Serif Ethiopic": "Noto Serif Ethiopic, serif",
  "Noto Serif Georgian": "Noto Serif Georgian, serif",
  "Noto Serif Gujarati": "Noto Serif Gujarati, serif",
  "Noto Serif Gurmukhi": "Noto Serif Gurmukhi, serif",
  "Noto Serif HK": "Noto Serif HK, serif",
  "Noto Serif Hebrew": "Noto Serif Hebrew, serif",
  "Noto Serif JP": "Noto Serif JP, serif",
  "Noto Serif KR": "Noto Serif KR, serif",
  "Noto Serif Kannada": "Noto Serif Kannada, serif",
  "Noto Serif Khmer": "Noto Serif Khmer, serif",
  "Noto Serif Khojki": "Noto Serif Khojki, serif",
  "Noto Serif Lao": "Noto Serif Lao, serif",
  "Noto Serif Malayalam": "Noto Serif Malayalam, serif",
  "Noto Serif Myanmar": "Noto Serif Myanmar, serif",
  "Noto Serif NP Hmong": "Noto Serif NP Hmong, serif",
  "Noto Serif Oriya": "Noto Serif Oriya, serif",
  "Noto Serif SC": "Noto Serif SC, serif",
  "Noto Serif Sinhala": "Noto Serif Sinhala, serif",
  "Noto Serif TC": "Noto Serif TC, serif",
  "Noto Serif Tamil": "Noto Serif Tamil, serif",
  "Noto Serif Telugu": "Noto Serif Telugu, serif",
  "Noto Serif Thai": "Noto Serif Thai, serif",
  "Noto Serif Tibetan": "Noto Serif Tibetan, serif",
  "Noto Serif Toto": "Noto Serif Toto, serif",
  "Noto Serif Vithkuqi": "Noto Serif Vithkuqi, serif",
  "Noto Serif Yezidi": "Noto Serif Yezidi, serif",
  "Noto Traditional Nushu": "Noto Traditional Nushu, sans-serif",
  "Nunito": "Nunito, sans-serif",
  "Nunito Sans": "Nunito Sans, sans-serif",
  "Ojuju": "Ojuju, sans-serif",
  "Old Standard TT": "Old Standard TT, serif",
  "Oleo Script": "Oleo Script, fantasy",
  "Oleo Script Swash Caps": "Oleo Script Swash Caps, fantasy",
  "Onest": "Onest, sans-serif",
  "Open Sans": "Open Sans, sans-serif",
  "Orbitron": "Orbitron, sans-serif",
  "Oswald": "Oswald, sans-serif",
  "Outfit": "Outfit, sans-serif",
  "Overlock": "Overlock, fantasy",
  "Overpass": "Overpass, sans-serif",
  "Overpass Mono": "Overpass Mono, monospace",
  "Oxanium": "Oxanium, fantasy",
  "Oxygen": "Oxygen, sans-serif",
  "PT Sans": "PT Sans, sans-serif",
  "PT Sans Caption": "PT Sans Caption, sans-serif",
  "PT Sans Narrow": "PT Sans Narrow, sans-serif",
  "PT Serif": "PT Serif, serif",
  "Padauk": "Padauk, sans-serif",
  "Palanquin": "Palanquin, sans-serif",
  "Palanquin Dark": "Palanquin Dark, sans-serif",
  "Parkinsans": "Parkinsans, sans-serif",
  "Passion One": "Passion One, fantasy",
  "Pathway Extreme": "Pathway Extreme, sans-serif",
  "Patrick Hand": "Patrick Hand, sans-serif",
  "Petrona": "Petrona, serif",
  "Phetsarath": "Phetsarath, serif",
  "Philosopher": "Philosopher, sans-serif",
  "Phudu": "Phudu, fantasy",
  "Piazzolla": "Piazzolla, serif",
  "Pixelify Sans": "Pixelify Sans, fantasy",
  "Platypi": "Platypi, serif",
  "Play": "Play, sans-serif",
  "Playfair": "Playfair, serif",
  "Playfair Display": "Playfair Display, serif",
  "Playfair Display SC": "Playfair Display SC, serif",
  "Playpen Sans": "Playpen Sans, sans-serif",
  "Plus Jakarta Sans": "Plus Jakarta Sans, sans-serif",
  "Podkova": "Podkova, serif",
  "Poltawski Nowy": "Poltawski Nowy, serif",
  "Pontano Sans": "Pontano Sans, sans-serif",
  "Poppins": "Poppins, sans-serif",
  "Pragati Narrow": "Pragati Narrow, sans-serif",
  "Pridi": "Pridi, serif",
  "Prompt": "Prompt, sans-serif",
  "Proza Libre": "Proza Libre, sans-serif",
  "Public Sans": "Public Sans, sans-serif",
  "Puritan": "Puritan, sans-serif",
  "Quantico": "Quantico, sans-serif",
  "Quattrocento": "Quattrocento, serif",
  "Quattrocento Sans": "Quattrocento Sans, sans-serif",
  "Quicksand": "Quicksand, sans-serif",
  "Qwitcher Grypen": "Qwitcher Grypen, sans-serif",
  "REM": "REM, sans-serif",
  "Radio Canada": "Radio Canada, sans-serif",
  "Radio Canada Big": "Radio Canada Big, sans-serif",
  "Rajdhani": "Rajdhani, sans-serif",
  "Raleway": "Raleway, sans-serif",
  "Rambla": "Rambla, sans-serif",
  "Ranga": "Ranga, fantasy",
  "Rasa": "Rasa, serif",
  "Readex Pro": "Readex Pro, sans-serif",
  "Recursive": "Recursive, sans-serif",
  "Red Hat Display": "Red Hat Display, sans-serif",
  "Red Hat Mono": "Red Hat Mono, monospace",
  "Red Hat Text": "Red Hat Text, sans-serif",
  "Red Rose": "Red Rose, fantasy",
  "Redacted Script": "Redacted Script, fantasy",
  "Reddit Mono": "Reddit Mono, monospace",
  "Reddit Sans": "Reddit Sans, sans-serif",
  "Reddit Sans Condensed": "Reddit Sans Condensed, sans-serif",
  "Reem Kufi": "Reem Kufi, sans-serif",
  "Reem Kufi Fun": "Reem Kufi Fun, sans-serif",
  "Rethink Sans": "Rethink Sans, sans-serif",
  "Roboto": "Roboto, sans-serif",
  "Roboto Condensed": "Roboto Condensed, sans-serif",
  "Roboto Mono": "Roboto Mono, monospace",
  "Roboto Serif": "Roboto Serif, serif",
  "Roboto Slab": "Roboto Slab, serif",
  "Rokkitt": "Rokkitt, serif",
  "Rosario": "Rosario, sans-serif",
  "Rowdies": "Rowdies, fantasy",
  "Rubik": "Rubik, sans-serif",
  "Ruda": "Ruda, sans-serif",
  "Rufina": "Rufina, serif",
  "Ruwudu": "Ruwudu, serif",
  "STIX Two Text": "STIX Two Text, serif",
  "SUSE": "SUSE, sans-serif",
  "Sahitya": "Sahitya, serif",
  "Saira": "Saira, sans-serif",
  "Saira Condensed": "Saira Condensed, sans-serif",
  "Saira Extra Condensed": "Saira Extra Condensed, sans-serif",
  "Saira Semi Condensed": "Saira Semi Condensed, sans-serif",
  "Sansita": "Sansita, sans-serif",
  "Sansita Swashed": "Sansita Swashed, fantasy",
  "Sarabun": "Sarabun, sans-serif",
  "Sarala": "Sarala, sans-serif",
  "Sarpanch": "Sarpanch, sans-serif",
  "Scada": "Scada, sans-serif",
  "Scheherazade New": "Scheherazade New, serif",
  "Schibsted Grotesk": "Schibsted Grotesk, sans-serif",
  "Sen": "Sen, sans-serif",
  "Shantell Sans": "Shantell Sans, fantasy",
  "Share": "Share, sans-serif",
  "Shippori Mincho": "Shippori Mincho, serif",
  "Shippori Mincho B1": "Shippori Mincho B1, serif",
  "Signika": "Signika, sans-serif",
  "Signika Negative": "Signika Negative, sans-serif",
  "Silkscreen": "Silkscreen, fantasy",
  "Sintony": "Sintony, sans-serif",
  "Skranji": "Skranji, fantasy",
  "Smooch Sans": "Smooch Sans, sans-serif",
  "Sofia Sans": "Sofia Sans, sans-serif",
  "Sofia Sans Condensed": "Sofia Sans Condensed, sans-serif",
  "Sofia Sans Extra Condensed": "Sofia Sans Extra Condensed, sans-serif",
  "Sofia Sans Semi Condensed": "Sofia Sans Semi Condensed, sans-serif",
  "Solway": "Solway, serif",
  "Sometype Mono": "Sometype Mono, monospace",
  "Sono": "Sono, sans-serif",
  "Sora": "Sora, sans-serif",
  "Sour Gummy": "Sour Gummy, sans-serif",
  "Source Code Pro": "Source Code Pro, monospace",
  "Source Sans 3": "Source Sans 3, sans-serif",
  "Source Serif 4": "Source Serif 4, serif",
  "Space Grotesk": "Space Grotesk, sans-serif",
  "Space Mono": "Space Mono, monospace",
  "Spectral": "Spectral, serif",
  "Spectral SC": "Spectral SC, serif",
  "Spline Sans": "Spline Sans, sans-serif",
  "Spline Sans Mono": "Spline Sans Mono, monospace",
  "Srisakdi": "Srisakdi, fantasy",
  "Stardos Stencil": "Stardos Stencil, fantasy",
  "Stick No Bills": "Stick No Bills, sans-serif",
  "Sulphur Point": "Sulphur Point, sans-serif",
  "Sumana": "Sumana, serif",
  "Sura": "Sura, serif",
  "Suwannaphum": "Suwannaphum, serif",
  "Syncopate": "Syncopate, sans-serif",
  "Syne": "Syne, sans-serif",
  "Tai Heritage Pro": "Tai Heritage Pro, serif",
  "Tajawal": "Tajawal, sans-serif",
  "Tangerine": "Tangerine, sans-serif",
  "Taviraj": "Taviraj, serif",
  "Teachers": "Teachers, sans-serif",
  "Teko": "Teko, sans-serif",
  "Tektur": "Tektur, fantasy",
  "Texturina": "Texturina, serif",
  "Thasadith": "Thasadith, sans-serif",
  "The Nautigal": "The Nautigal, sans-serif",
  "Tienne": "Tienne, serif",
  "Tillana": "Tillana, fantasy",
  "Tinos": "Tinos, serif",
  "Titillium Web": "Titillium Web, sans-serif",
  "Tomorrow": "Tomorrow, sans-serif",
  "Tourney": "Tourney, fantasy",
  "Trirong": "Trirong, serif",
  "Trispace": "Trispace, sans-serif",
  "Trochut": "Trochut, fantasy",
  "Truculenta": "Truculenta, sans-serif",
  "Tsukimi Rounded": "Tsukimi Rounded, sans-serif",
  "Turret Road": "Turret Road, fantasy",
  "Ubuntu": "Ubuntu, sans-serif",
  "Ubuntu Mono": "Ubuntu Mono, monospace",
  "Ubuntu Sans": "Ubuntu Sans, sans-serif",
  "Ubuntu Sans Mono": "Ubuntu Sans Mono, monospace",
  "Unbounded": "Unbounded, sans-serif",
  "Unkempt": "Unkempt, fantasy",
  "Unna": "Unna, serif",
  "Urbanist": "Urbanist, sans-serif",
  "Varta": "Varta, sans-serif",
  "Vazirmatn": "Vazirmatn, sans-serif",
  "Vesper Libre": "Vesper Libre, serif",
  "Victor Mono": "Victor Mono, monospace",
  "Volkhov": "Volkhov, serif",
  "Vollkorn": "Vollkorn, serif",
  "Vollkorn SC": "Vollkorn SC, serif",
  "Wavefont": "Wavefont, fantasy",
  "Wittgenstein": "Wittgenstein, serif",
  "Wix Madefor Display": "Wix Madefor Display, sans-serif",
  "Wix Madefor Text": "Wix Madefor Text, sans-serif",
  "Work Sans": "Work Sans, sans-serif",
  "Yaldevi": "Yaldevi, sans-serif",
  "Yanone Kaffeesatz": "Yanone Kaffeesatz, sans-serif",
  "Yantramanav": "Yantramanav, sans-serif",
  "Yrsa": "Yrsa, serif",
  "Ysabeau": "Ysabeau, sans-serif",
  "Ysabeau Infant": "Ysabeau Infant, sans-serif",
  "Ysabeau Office": "Ysabeau Office, sans-serif",
  "Ysabeau SC": "Ysabeau SC, sans-serif",
  "Zain": "Zain, sans-serif",
  "Zen Kaku Gothic Antique": "Zen Kaku Gothic Antique, sans-serif",
  "Zen Kaku Gothic New": "Zen Kaku Gothic New, sans-serif",
  "Zen Maru Gothic": "Zen Maru Gothic, sans-serif",
  "Zen Old Mincho": "Zen Old Mincho, serif",
  "Zilla Slab": "Zilla Slab, serif",
  "Zilla Slab Highlight": "Zilla Slab Highlight, serif"
}